import { getAccountData } from '../apis/rebelmouse.js';
import getStore from '../store/index.js';
import { actions as accountActions } from '../store/state/accountData.js';

export async function preloadAccountData() {
  const store = getStore();

  const state = store.getState();

  if (state.accountData.loading || state.accountData.data != null) {
    return;
  }

  store.dispatch(accountActions.START_LOADING());
  try {
    const accountData = await getAccountData();
    store.dispatch(accountActions.ON_DATA(accountData));
  } catch {
    store.dispatch(accountActions.FINISH_LOADING());
  }
}
